module.exports = __webpack_public_path__ + "img/alex.b8014edc.svg";